module.exports = __webpack_public_path__ + "img/CN.26187a64.svg";